import React from 'react';
import DevTestToolbar from './DevTestToolbar.jsx';

function toolbarShellProps(props) {
  const defaults = {
    activeSession: null,
    activeWorkspaceTab: '',
    canvasAvailable: false,
    canvasDiagnostics: {},
    config: {},
    projectSlot: null,
    showCanvasPanel: false,
    viewModel: {},
  };
  return {
    ...props,
    ...Object.fromEntries(Object.entries(defaults).map(([key, fallback]) => [
      key, props[key] === undefined ? fallback : props[key],
    ])),
  };
}

export default function DevToolbarShell(props) {
  const {
    activeSession,
    activeWorkspaceTab,
    canvasAvailable,
    canvasDiagnostics,
    config,
    projectSlot,
    showCanvasPanel,
    surfaceNode,
    themeTokens,
    viewModel,
  } = toolbarShellProps(props);
  if (!config.enabled) {
    return surfaceNode;
  }

  return (
    <div
      className="flare-chat-dev-shell"
      style={{
        background: themeTokens.appBg,
        display: 'flex',
        flexDirection: 'column',
        height: 'var(--flare-app-viewport-height, 100dvh)',
        minHeight: 0,
        overflow: 'hidden',
      }}
    >
      <DevTestToolbar
        activeSession={activeSession}
        activeWorkspaceTab={activeWorkspaceTab}
        canvasAvailable={canvasAvailable}
        canvasDiagnostics={canvasDiagnostics}
        config={config}
        projectSlot={projectSlot}
        showCanvasPanel={showCanvasPanel}
        viewModel={viewModel}
      />
      <div style={{ flex: '1 1 auto', minHeight: 0 }}>
        {surfaceNode}
      </div>
    </div>
  );
}
